import type { ComponentProps } from 'react';
import { Elements } from '@stripe/react-stripe-js';

import { buildExpressElementsOptions } from '@/utils/stripe/expressCheckoutOptions';

import PaymentMethodsScreen from './PaymentMethodsScreen';

import { type SelectedPlanBlockProps } from '../common/SelectedPlanBlock';
import { type OnExpressCheckoutConfirm } from '@/utils/stripe/expressCheckoutHooks';

interface PaymentMethodsScreenAdapterBaseProps {
  selectedPlanBlockData: SelectedPlanBlockProps & { isWebRoute?: boolean };
  stripePromise: ComponentProps<typeof Elements>['stripe'];
  onExpressCheckoutConfirm: OnExpressCheckoutConfirm;
  onBackButtonClick: () => void;
  onCardFormButtonClick: () => void;
  isSubmitting?: boolean;
}

const PaymentMethodsScreenAdapterBase = ({
  selectedPlanBlockData,
  isSubmitting,
  stripePromise,
  onExpressCheckoutConfirm,
  onBackButtonClick,
  onCardFormButtonClick,
}: PaymentMethodsScreenAdapterBaseProps) => {
  const { selectedPlan } = selectedPlanBlockData;

  const nestedElementsOptions = buildExpressElementsOptions(selectedPlan);

  return (
    <Elements stripe={stripePromise} options={nestedElementsOptions}>
      <PaymentMethodsScreen
        selectedPlanBlockData={selectedPlanBlockData}
        isWebRoute={selectedPlanBlockData.isWebRoute}
        isSubmitting={isSubmitting}
        onExpressCheckoutConfirm={onExpressCheckoutConfirm}
        onBackButtonClick={onBackButtonClick}
        onCardFormButtonClick={onCardFormButtonClick}
      />
    </Elements>
  );
};

export default PaymentMethodsScreenAdapterBase;
